<template>
  <router-view class="mb-12 pb-10 mb-md-0 pb-md-0"></router-view>
</template>

<script>
export default {
  name: "Education",
  metaInfo: {
    title: "Учебные материалы"
  }
};
</script>

<style scoped></style>
